import Icon from '../components/Icon.vue'

Icon.register({
  'rss-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM112 416C85.5 416 64 394.5 64 368S85.5 320 112 320 160 341.5 160 368 138.5 416 112 416zM269.5 416H235.2C229.2 416 224.1 411.4 223.8 405.4 218.5 325.3 154.5 261.4 74.6 256.2 68.6 255.9 64 250.8 64 244.8V210.5C64 203.9 69.5 198.7 76 199 186.5 205 275 293.6 281 404 281.3 410.5 276.1 416 269.5 416zM372.6 416H338.2C332.1 416 327.1 411.1 326.8 405 321.2 268.4 211.6 158.8 75 153.2 68.9 152.9 64 147.9 64 141.8V107.4C64 101 69.3 95.8 75.8 96 243.6 102 378 237.2 384 404.2 384.2 410.7 379 416 372.6 416z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/rss-square.js
// module id = 7R73
// module chunks = 144